import * as actionTypes from './actionTypes';

export const establecerParametros = parameters => ({
  type: actionTypes.SET_SELECTED_PARAMETERS,
  payload: parameters
});

export const establecerGoogleKey = pGoogleKey => ({
    type: actionTypes.SET_GOOGLE_KEY_PARAMETER,
    payload: pGoogleKey
});